import { Misconduct as MisconductForm } from '@bgea-js/form-templates';
import "../../../../src/content/misconduct-host-page/misconduct-styles.scss";
import * as React from 'react';
export default {
  MisconductForm,
  React
};